import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

type InstallationCreateWizardNavProps = {
  stepIndex: number
  lastStepIndex: number
  dashboardLink: string
  isCreating: boolean
  onBack: () => void
  onNext: () => void
  onCreate: () => void
}

export function InstallationCreateWizardNav({
  stepIndex,
  lastStepIndex,
  dashboardLink,
  isCreating,
  onBack,
  onNext,
  onCreate,
}: InstallationCreateWizardNavProps) {
  const { t } = useTranslation('installations')
  const showBack = stepIndex > 0
  const showNext = stepIndex < lastStepIndex

  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <div className="flex gap-2">
        {showBack ? (
          <Button type="button" variant="outline" onClick={onBack}>
            {t('create.wizard.back')}
          </Button>
        ) : null}
      </div>
      <div className="flex gap-2">
        <Button type="button" variant="outline" asChild>
          <Link to={dashboardLink}>{t('create.cancel')}</Link>
        </Button>
        {showNext ? (
          <Button type="button" onClick={onNext}>
            {t('create.wizard.next')}
          </Button>
        ) : (
          <Button type="button" disabled={isCreating} onClick={onCreate}>
            {isCreating ? <Loader2 className="size-4 animate-spin" /> : null}
            {t('create.submit')}
          </Button>
        )}
      </div>
    </div>
  )
}
